import React from 'react';
import {useTranslation} from "react-i18next";
import {ConfigApi, OrderType} from "../../../../services/Api/types";
import CategoryHelper from "../../../../services/Menu/services/Category/CategoryHelper";

interface Props {
    locale?: string;
    pickupDate: string | undefined;
    category: any;
    orderType: OrderType;
    menus: any[];
    availabilities: any[];
    items: any[];
    config: ConfigApi | undefined;
}

const MenuCategoryAvailabilityHeading = ({
                                             locale,
                                             category,
                                             orderType,
                                             menus,
                                             items,
                                             pickupDate,
                                             availabilities,
                                             config
                                         }: Props) => {
    const {t} = useTranslation();
    const infos = CategoryHelper.getAvailabilityInfo(category, menus, items, availabilities, config, orderType, pickupDate, t, locale, true);

    const getFullInfo = () => {
        const result: string[] = [];

        if (infos.length === 1) {
            const info = infos[0];

            if ((info.currentType || info.includeCurrentType) && !info.isNowAvailable && info.dateText) {
                result.push(`${info.text} ${info.dateText.toLowerCase()}`);
            } else if (!info.currentType && !info.includeCurrentType) {
                if (info.isNowAvailable) {
                    result.push(`${info.text} ${info.typesText}`);
                } else {
                    if (info.dateText) {
                        result.push(`${info.text} ${info.typesText}. ${info.dateText}`);
                    }
                }
            }

            return result;
        }

        if (infos.length > 1) {
            infos.forEach((info) => {
                let title = `${info.text} ${info.typesText}`;

                if (!info.isNowAvailable && info.dateText) {
                    title += ` - ${info.dateText.toLowerCase()}`;
                }

                result.push(title);
            })
        }

        return result.join(". ");
    }

    return (
        <div className="d-flex align-items-center fw-normal menu-category-availability-heading">
            <p className="mb-0 text-warning">
                {getFullInfo()}
            </p>
        </div>
    )
}

export default MenuCategoryAvailabilityHeading;